import RichText from '../../../../../hoc/components/rich-text';
import React from 'react';
type FeedbackProps = {
	feedback: string;
};

const Feedback = ({ feedback }: FeedbackProps) => {
	return (
		<>
			<div
				className={`md:px-8 text-center text-base md:text-lg leading-6 md:mt-4 mt-2 md:mb-6 mb-2`}>
				<RichText html={feedback} />
			</div>
		</>
	);
};

export default Feedback;
